export default function mergePaginatedUsers(existing, incoming) {
  const existingUsers = existing.users || [];
  const incomingUsers = incoming.users || [];
  return {
    ...incoming,
    users: [...existingUsers, ...incomingUsers],
  };
}
